import axiosClient from "./axiosClient";

export async function sendAdminNotification(payload) {
  const response = await axiosClient.post("/admin/notifications/send", payload);
  return response.data;
}

export async function getNotifications() {
  const response = await axiosClient.get("/notifications");
  return response.data;
}

export async function markAllNotificationsRead() {
  await axiosClient.put("/notifications/read-all");
}

export async function markNotificationRead(id) {
  await axiosClient.put(`/notifications/${id}/read`);
}
